import React from 'react'

import {LB_LOADING} from "../../../../components/i18n/i18n";

const LoadingComponent = ({title = LB_LOADING}) => <div className={'loading-data'}>
    <i className="fa fa-spinner fa-spin"/>
    <br/>
    <span>{title}</span>
</div>

export default LoadingComponent